import { Injectable } from '@angular/core';

import { Analytics } from '@recruitee/analytics';

import type { OverdueTrackingEvent } from '../analytics/overdue-candidate.analytics';

@Injectable({ providedIn: 'root' })
export class OverdueCandidatesTrackingService {
  constructor(private analytics: Analytics) {}

  public track(event: OverdueTrackingEvent): void {
    this.analytics.track(event.name, event.properties);
  }
}
